export class StudentsAttendancesListRequest {
    exerciseId: number;
    schoolId: number;
    year: number;
    month: number;
    serviceId: number;
    showData: boolean;
    orderAttendance: number;
  }